import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Actions as ApiCallActions } from '../../../redux/apiCall/reducers'
import useI18n from '../../../i18n/useI18n'
import general from '../../../utils/general'
import './InfoAccordions.scss'

// HTML içeriği güvenli bir şekilde render eden yardımcı fonksiyon
const createMarkup = (html) => {
  return { __html: html || '' }
}

const InfoAccordions = ({ university }) => {
  const [openIndex, setOpenIndex] = useState(null)
  const [faculties, setFaculties] = useState([])
  const [facultiesLoading, setFacultiesLoading] = useState(false)
  const { t, language } = useI18n()
  const dispatch = useDispatch()

  useEffect(() => {
    if (university?.id) {
      setFacultiesLoading(true)
      dispatch(
        ApiCallActions.Get({
          url: 'programs/faculties',
          query: { universityId: university.id },
          showAlertOnError: false,
          showLoading: false,
          onSuccess: ({ data }) => {
            const facultiesData = data?.data || data || []
            setFaculties(Array.isArray(facultiesData) ? facultiesData : [])
            setFacultiesLoading(false)
          },
          onError: () => {
            setFaculties([])
            setFacultiesLoading(false)
          }
        })
      )
    }
  }, [university?.id, dispatch])

  const accordionItems = [
    {
      title: t('UNIVERSITY_ACCORDION_ABOUT_TITLE', {
        name: university?.name || t('UNIVERSITY_HERO_FALLBACK_NAME')
      }),
      icon: 'zmdi-info',
      content: university?.about || `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.`
    },
    {
      title: t('UNIVERSITY_ACCORDION_CAMPUS_LIFE_TITLE'),
      icon: 'zmdi-city',
      content: university?.campusLife || `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Morbi tempus iaculis urna id volutpat. Phasellus faucibus scelerisque eleifend donec pretium vulputate sapien. Sed blandit libero volutpat sed cras ornare arcu dui. Vivamus arcu felis bibendum ut tristique et egestas quis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer enim neque volutpat ac tincidunt vitae semper quis lectus. At ultrices mi tempus imperdiet nulla malesuada pellentesque elit eget gravida.`
    },
    {
      title: t('UNIVERSITY_ACCORDION_RANKING_TITLE'),
      icon: 'zmdi-star',
      content: university?.ranking || `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed pulvinar proin gravida hendrerit lectus. Faucibus vitae aliquet nec ullamcorper sit amet risus nullam eget. Eget nunc scelerisque viverra mauris in aliquam sem fringilla. Nibh ipsum consequat nisl vel pretium lectus quam id leo. Volutpat lacus laoreet non curabitur gravida arcu ac tortor. Ut etiam sit amet nisl purus in mollis nunc sed. Sed risus ultricies tristique nulla aliquet enim tortor at auctor.`
    },
    {
      title: t('UNIVERSITY_ACCORDION_APPLICATION_TITLE'),
      icon: 'zmdi-file-text',
      content: university?.applicationInfo || `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim blandit volutpat maecenas volutpat blandit aliquam etiam erat. Nibh tellus molestie nunc non blandit massa enim nec. Eget gravida cum sociis natoque penatibus et magnis dis parturient montes. Sed vulputate mi sit amet mauris commodo quis imperdiet massa. Aliquam id diam maecenas ultricies mi eget mauris pharetra et ultrices. Nunc sed velit dignissim sodales ut eu sem integer vitae.`
    },
    {
      title: t('UNIVERSITY_ACCORDION_FACULTIES_TITLE'),
      icon: 'zmdi-balance',
      customRender: () => {
        if (facultiesLoading) {
          return <div className="p-3 text-center text-muted"><i className="zmdi zmdi-refresh zmdi-hc-spin m-r-5"></i> {t('COMMON_LOADING', 'Yükleniyor...')}</div>
        }
        if (!faculties || faculties.length === 0) {
          return <div className="p-3 text-center text-muted">{t('UNIVERSITY_DETAIL_FACULTIES_EMPTY', 'Fakülte bulunamadı')}</div>
        }
        return (
          <ul className="list-group list-group-flush" style={{ margin: 0, padding: 0 }}>
            {faculties.map((f, i) => {
              const name = general.getLocaleValue(f, 'faculty', language) || f.faculty || ''
              return (
                <li key={i} className="list-group-item d-flex align-items-center" style={{ border: 'none', padding: '10px 15px', borderBottom: '1px solid #f1f5f9' }}>
                  <i className="zmdi zmdi-balance text-primary m-r-10" style={{ fontSize: '18px' }}></i>
                  {name}
                </li>
              )
            })}
          </ul>
        )
      }
    },
    {
      title: t('UNIVERSITY_ACCORDION_SCHOLARSHIPS_TITLE'),
      icon: 'zmdi-money',
      content: university?.scholarships || `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Magna fringilla urna porttitor rhoncus dolor purus non enim praesent. Elementum integer enim neque volutpat ac tincidunt vitae semper quis. Sed blandit libero volutpat sed cras ornare arcu dui vivamus. Nibh tellus molestie nunc non blandit massa enim nec dui. Eget gravida cum sociis natoque penatibus et magnis dis parturient montes. Ultrices tincidunt arcu non sodales neque sodales ut etiam sit.`
    }
  ]

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className="info-accordions-section">
      <div className="container-fluid">
        <div className="row">
          {accordionItems.map((item, index) => (
            <div key={index} className="col-lg-6 col-md-12 mb-4">
              <div className={`accordion-item ${openIndex === index ? 'open' : ''}`}>
                <button
                  className="accordion-header"
                  onClick={() => toggleAccordion(index)}
                  aria-expanded={openIndex === index}
                >
                  <div className="accordion-icon">
                    <i className={`zmdi ${item.icon}`}></i>
                  </div>
                  <span className="accordion-title">{item.title}</span>
                  <div className="accordion-arrow">
                    <i className={`zmdi zmdi-chevron-${openIndex === index ? 'up' : 'down'}`}></i>
                  </div>
                </button>
                <div className="accordion-content">
                  {item.customRender ? (
                    item.customRender()
                  ) : (
                    <div 
                      className="accordion-body ck-content-preview"
                      dangerouslySetInnerHTML={createMarkup(item.content)}
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default InfoAccordions

